import React from 'react';

import MediaList from 'application/components/MediaList';

import InfiniteItemList from '@zvuk-b2b/react-uikit/ui/InfiniteItemList';
import { StreamDemoType } from 'application/pages/types';
import SkeletonItem from './MediaListItemSkeleton';
import { MediaListProps, MediafileType } from './types';

export type InfiniteMediaListProps = MediaListProps & {
  totalItemsCount?: number;
  hasNextPage?: boolean;
  itemListSkeleton?: React.ReactNode;
  loadMore: () => void;
  streamDemo?: StreamDemoType | null;
  isStreamPlaying?: boolean;
};

const InfiniteMediaList = ({
  elementId,
  loadMore,
  hasNextPage,
  className,
  mediafiles,
  totalItemsCount = mediafiles.length,
  streamId,
  withDislikes,
  withLikes,
  withPlaytime,
  playtimeName,
  timezone,
  itemListSkeleton,
  streamDemo,
  isStreamPlaying,
  mediaListItemIcons,
}: InfiniteMediaListProps) => (
  <InfiniteItemList<MediafileType, MediaListProps>
    itemListRenderer={MediaList}
    itemListRendererProps={{
      elementId,
      className,
      mediafiles,
      streamId,
      withDislikes,
      withLikes,
      withPlaytime,
      playtimeName,
      timezone,
      itemListSkeleton,
      streamDemo,
      isStreamPlaying,
      mediaListItemIcons,
    }}
    items={mediafiles}
    itemListSkeleton={itemListSkeleton ?? <SkeletonItem />}
    loadMore={loadMore}
    totalItemsCount={totalItemsCount}
    hasNextPage={hasNextPage}
  />
);

export default InfiniteMediaList;
